import React, { Component } from 'react';
import swal from "sweetalert";
import { toast } from "react-toastify";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import VisibilitySharpIcon from '@material-ui/icons/VisibilitySharp';
import { Button, Form, Table, Image, Modal, Tabs, Tab, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PiArrowsOutThin, PiNotePencil, PiTrash, PiTelegramLogo, PiCopy } from "react-icons/pi";

import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../loader/loader';
import { getDate } from '../../../function';
import PreviewThumbnail from '../../preview/preview';
import TestEmails from '../../test-campaign-email/test-campaign-email';
import imageDefault from "../../../assets/campaign-thumbnail-phishing.png";
import swalAlert from '../../../swalFunction';
import './campaign-preview.css'
import LaunchNewModal from '../../launch-modal/launch-new-modal';
import { collectTemplateCourseIds } from '../collect-template-course-ids';

export default class CampaignPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
            page: null,
            game: null,
            user: null,
            emails: '',
            loading: true,
            template: null,
            category: null,
            language: null,
            subject: null,
            training: null,
            bluePage: false,
            attackType: null,
            categoryId: null,
            showModal: false,
            landing_url: null,
            campaignName: null,
            from_address: null,
            awarenessPath: null,
            simulationType: null,
            showTestModal: false,
            emailTracking: false,
            capture_passwords: false,
            capture_credentials: false,
            credential_harvesting: false,
            status: null,

            templateName: null,
            brodcastName: null,

            imageURL: '',
            courseName: '',
            previewURL: '',
            lmsCourses: [],
            activeCourses: [],
            classCSS: {
                Active: "badges",
                Inactive: "badges",
                Draft: "badges",
            },
            courseIds: [],
            myWindow: null,

            currentSrc: '',
            previewType: '',
            showThumbnail: false,

            firstname: '',
            lastname: '',
            tab: 'simulation',
            templateImg: '',
            showLaunchNewModal: false,
            // System templates are cloned before test/run; this holds the cloned "My Template" id.
            clonedCampaignTemplateId: null,

            targetInteractionType: "",
            isAIbased: false,
        }
        this.load();
    }

    load = () => {
        this.setState({ loading: true })
        axios.get((this.props.keyType === "system" ? '/api/store/fetch-system-template/preview/' : '/api/campaign/template/preview/') + parseInt(this.props.campaignTemplateId, 10), {})
            .then(res => {
                var campaignTemplate = res.data.campaign_template;
                const courseIds = collectTemplateCourseIds(campaignTemplate);
                const attackName = campaignTemplate.attack_type ? campaignTemplate.attack_type.name : null;
                const titRaw = campaignTemplate.targetInteractionType;
                const normalizedTitRaw = titRaw != null ? String(titRaw).trim().toLowerCase() : "";
                let derivedIsAI = campaignTemplate.isAIbased;
                if (derivedIsAI !== true && derivedIsAI !== false && normalizedTitRaw !== "") {
                    if (normalizedTitRaw === "inbound") derivedIsAI = true;
                    else if (normalizedTitRaw === "outbound") derivedIsAI = false;
                }
                if (derivedIsAI !== true && derivedIsAI !== false) derivedIsAI = false;
                /**
                 * Keep Vishing mode consistent for Create Campaign launch:
                 * - If TIT exists (inbound/outbound), trust it and sync isAIbased from TIT.
                 * - Else derive TIT from isAIbased fallback.
                 */
                let normalizedTargetInteractionType = campaignTemplate.targetInteractionType;
                if (attackName === "Vishing" || attackName === "WhatsApp") {
                    if (normalizedTitRaw === "inbound" || normalizedTitRaw === "outbound") {
                        normalizedTargetInteractionType = normalizedTitRaw;
                        derivedIsAI = normalizedTitRaw === "inbound";
                    } else {
                        normalizedTargetInteractionType = derivedIsAI ? "inbound" : "outbound";
                    }
                }
                this.setState({
                    loading: false,
                    user: res.data.user,
                    pageImg: res.data.pagePath,
                    game: campaignTemplate.game,
                    type: campaignTemplate.type,
                    templateImg: res.data.templatePath,
                    campaignName: campaignTemplate.name,
                    training: campaignTemplate.courseId,
                    awarenessPath: res.data.awarenessPath,
                    credential_harvesting: campaignTemplate.credential_harvesting,
                    from_address: campaignTemplate.sender ? campaignTemplate.sender.from_address : null,

                    subject: campaignTemplate.template ? campaignTemplate.template.subject : null,
                    emailTracking: campaignTemplate.template ? campaignTemplate.template.emailTracking : null,

                    templateName: campaignTemplate.template ? campaignTemplate.template.templateName : null,
                    brodcastName: campaignTemplate.template ? campaignTemplate.template.brodcastName : null,
                    status: campaignTemplate.status,

                    category: campaignTemplate.category ? campaignTemplate.category.name : null,
                    categoryId: campaignTemplate.category ? campaignTemplate.category.id : null,
                    language: campaignTemplate.language ? campaignTemplate.language.name : null,
                    attackType: campaignTemplate.attack_type ? campaignTemplate.attack_type.name : null,
                    simulationType: campaignTemplate.simulation_type ? campaignTemplate.simulation_type.name : {},

                    bluePage: campaignTemplate.page ? campaignTemplate.page.bluePage : null,
                    landing_url: campaignTemplate.page ? campaignTemplate.page.landing_url : null,
                    capture_passwords: campaignTemplate.page ? campaignTemplate.page.capture_passwords : null,
                    capture_credentials: campaignTemplate.page ? campaignTemplate.page.capture_credentials : null,
                    awarenessUrl: res.data.awarenessUrl,

                    targetInteractionType: normalizedTargetInteractionType,
                    isAIbased: derivedIsAI,

                    courseIds,
                    lmsCourses: [],
                    activeCourses: [],
                    imageURL: '',
                    previewURL: '',
                }, () => {
                    if (this.props.openCreateCampaignOnOpen && !this.state.showLaunchNewModal) {
                        this.setState({ showLaunchNewModal: true });
                    }
                    if (this.props.openTestOnOpen && !this.state.showTestModal) {
                        if ((this.state.status || '').toLowerCase() === 'draft') {
                            toast.error("Draft templates cannot be tested");
                        } else {
                            this.setState({ showTestModal: true });
                        }
                    }
                    if (courseIds.length) {
                        this.loadCourseLMS();
                    }
                })
            })
            .catch(error => {
                this.setState({ loading: false })
                apiError(error)
            })
    }

    testCampaign = (targetDetails) => {
        // For system templates the cloned "My Template" id is used; My Templates use their own id.
        const effectiveTemplateId = this.state.clonedCampaignTemplateId || this.props.campaignTemplateId;
        if (parseInt(effectiveTemplateId, 10)) {
            this.setState({ loading: true })
            axios.post('/api/simulation/test', {
                targetDetails,
                campaignTemplateId: parseInt(effectiveTemplateId, 10),
            })
                .then(res => {
                    toast.success("Test campaign run successfully");
                    this.setState({ loading: false, showTestModal: false })
                    setTimeout(() => { window.open('/campaign/test-results/?attackTypeId=' + this.state.attackType) }, 500);
                    this.setState({ loading: false })
                })
                .catch(error => {
                    this.setState({ loading: false })
                    apiError(error);
                })
        } else toast.error("Invalid Campaign Template");
    }

    launchCampaignTemplate = () => {
        this.setState({ showLaunchNewModal: true });
    }

    /**
     * System templates can't be tested/run directly. Silently clone the template, then:
     *  - if the clone is saved (completed): proceed with the action using the cloned id;
     *  - if the clone is a draft: prompt the user to review & save it first.
     */
    handleSystemClone = (action) => {
        const sourceId = parseInt(this.props.campaignTemplateId, 10);
        if (!sourceId) {
            toast.error("Invalid Campaign Template");
            return;
        }
        const cloneUrl = this.props.campaignType === "System Templates"
            ? "/api/store/clone-campaign-template/"
            : "/api/campaign/template/clone/";
        this.setState({ loading: true });
        axios
            .post(cloneUrl + sourceId, {})
            .then((res) => {
                const clonedId = res.data.campaignTemplateId != null ? res.data.campaignTemplateId : res.data.response?.id;
                const status = (res.data.status || "").toLowerCase();
                if (!clonedId) {
                    this.setState({ loading: false });
                    toast.error("Failed to clone the system template");
                    return;
                }
                if (status === "draft") {
                    this.setState({ loading: false });
                    this.showClonedDraftAlert(clonedId);
                    return;
                }
                // Cloned template is saved — proceed with the requested action against the clone.
                if (action === "test") {
                    this.setState({ loading: false, clonedCampaignTemplateId: clonedId, showTestModal: true });
                } else {
                    this.setState({ loading: false, clonedCampaignTemplateId: clonedId, showLaunchNewModal: true });
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                apiError(error);
            });
    };

    /** Draft clone can't be used yet: inform the user and offer to open its preview page to review & save. */
    showClonedDraftAlert = (clonedTemplateId) => {
        swal({
            title: "Template Cloned",
            text: "This system template has been cloned to your templates, but it is still a draft. Please review and save the cloned template before running the campaign.",
            icon: "info",
            buttons: { proceed: { text: "Proceed", value: true, className: "btn-custom-info" } },
            closeOnClickOutside: false,
        }).then((proceed) => {
            if (proceed && clonedTemplateId != null) {
                this.props.handleModal(false);
                if (this.props.nextPath) this.props.nextPath("/templates/" + clonedTemplateId + "?preview=1");
            }
        });
    };

    loadCourseLMS = () => {
        const courseIds = this.state.courseIds;
        if (!courseIds || !courseIds.length) return;
        this.setState({ loading: true });
        axios.get('/api/lms/course-detail', {
            params: {
                courseIds,
            }
        })
            .then(res => {
                const courses = Array.isArray(res.data?.courses) ? res.data.courses : [];
                var courseName = {};
                for (let i = 0; i < courses.length; i++) {
                    courseName[courses[i].id] = courses[i].name;
                }
                this.setState({
                    loading: false,
                    courseName: courseName,
                    imageURL: res.data.imageURL || '',
                    lmsCourses: courses,
                    activeCourses: Array.isArray(res.data?.activeCourses) ? res.data.activeCourses : [],
                    previewURL: res.data.previewURL || '',
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                apiError(err)
            })
    }

    handleLMS = async (courseId) => {
        axios.get('/api/lms', {
            params: {
                url: `${this.state.previewURL}${courseId}?r=Sw4s56g`
            }
        })
            .then(res => {
                const allowedBaseURL = process.env.REACT_APP_LMS_URL;
                const allowedDomain = new URL(allowedBaseURL).hostname;
                const url = new URL(res.data.url);

                const allowedDomainParts = allowedDomain.split('.').slice(-2).join('.');
                const urlDomainParts = url.hostname.split('.').slice(-2).join('.');

                // Validate domain
                if (urlDomainParts !== allowedDomainParts) {
                    swalAlert("Security Alert", "Invalid redirect URL detected!", "error");
                    return;
                }

                // Prevent Open Redirection
                const redirectUrl = url.searchParams.get("url"); // Potential redirection target
                if (redirectUrl) {
                    try {
                        const parsedRedirectUrl = new URL(redirectUrl, allowedBaseURL); // Resolve relative paths
                        const redirectDomainParts = parsedRedirectUrl.hostname.split('.').slice(-2).join('.');

                        if (redirectDomainParts !== allowedDomainParts) {
                            swalAlert("Security Alert", "Invalid redirect target detected!", "error");
                            return;
                        }
                    } catch (error) {
                        swalAlert("Security Alert", "Invalid redirect target detected!", "error");
                        return;
                    }
                }
                window.open(res.data.url, '_blank');
            })
            .catch(err => {
                apiError(err);
            });
    }

    deleteCampaignTemplate = (campaignTemplateId) => {
        swal({
            title: "Do you want to delete CampaignTemplate?",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
        }).then((willSuccess) => {
            if (willSuccess) {
                axios
                    .delete("/api/campaign/template/" + campaignTemplateId, {})
                    .then((r) => {
                        toast.success("CampaignTemplate Deleted Successfully");
                        this.props.handleModal(false);
                        this.props.load();
                    })
                    .catch((error) => {
                        apiError(error);
                    });
            }
        });
    };

    copyCampaignTemplate = (campaignTemplateId) => {
        swal({
            title: "Do you want to clone CampaignTemplate?",
            icon: "info",
            buttons: ["No", "Yes"],
        }).then(async (willSuccess) => {
            if (willSuccess) {
                await this.setState({ loading: true });
                axios
                    .post((this.props.campaignType === "System Templates" ? "/api/store/clone-campaign-template/" : "/api/campaign/template/clone/") + campaignTemplateId, { forceNew: true })
                    .then((res) => {
                        this.setState({ loading: false });
                        toast.success("Campaign Template Added Successfully");
                        this.props.handleKeySelect('templates');
                        this.props.handleModal();
                        this.props.load();
                        // this.props.nextPath("/templates/" + res.data.campaignTemplateId)
                    })
                    .catch((error) => {
                        this.setState({ loading: false });
                        apiError(error);
                    });
            }
        });
    };

    getStatusInfo = (status, inCampaign) => {
        const courseIsDraft = status === "Draft";
        const courseIsActive = status === "Published" && !!inCampaign
        const courseIsInActive = status === "Active" || (status !== "Draft" && !inCampaign);

        return { courseIsDraft, courseIsActive, courseIsInActive }
    }

    getNewCourseStatus = (status, courseId) => {
        const inCampaign = this.state.activeCourses ? !!this.state.activeCourses[courseId] : false;
        const { courseIsDraft, courseIsActive, courseIsInActive } = this.getStatusInfo(status, inCampaign)
        let courseStatus = "";

        switch (true) {
            case courseIsDraft: courseStatus = "Draft"; break;
            case courseIsActive: courseStatus = "Active"; break;
            case courseIsInActive: courseStatus = "Inactive"; break;
        }
        return courseStatus;
    }

    render() {
        const isDraftTemplate = (this.state.status || '').toLowerCase() === 'draft';
        const isSystemTemplate = this.props.campaignType === "System Templates";
        const effectiveTemplateId = this.state.clonedCampaignTemplateId || this.props.campaignTemplateId;
        const effectiveCredentialHarvesting = this.props.credentialHarvestingOverride !== undefined ? this.props.credentialHarvestingOverride : this.state.credential_harvesting;
        const dimCredentialHarvestingSections = this.props.dimCredentialHarvestingSections && !effectiveCredentialHarvesting;
        const isAiWhatsapp = this.state.attackType === "WhatsApp" && this.state.targetInteractionType === "inbound" && this.state.isAIbased === true;
        const isNormalWhatsapp = this.state.attackType === "WhatsApp" && !isAiWhatsapp;
        const draftTemplateTooltip = (
            <Tooltip id="draft-template-tooltip">
                For Draft templates, campaign cannot be created
            </Tooltip>
        );
        const testDraftTemplateTooltip = (
            <Tooltip id="test-draft-template-tooltip">
                Draft templates cannot be tested
            </Tooltip>
        );

        return (
            <Modal className="info-filter right right-preview-modal" show={this.props.show} onHide={() => this.props.handleModal(false)} autoFocus keyboard>
                <Modal.Header closeButton>
                    <div>
                        <h5>Template Details</h5>
                        <p>View your template details</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div id="preview">
                        {!this.props.fromCampaign ?
                            <div className='btn-container tempDdtailsBtn'>
                                {(this.props.campaignType === "My Templates") ?
                                    <Button
                                        variant="secondary"
                                        className="mr-2"
                                        onClick={() => this.props.nextPath("/templates/" + this.props.campaignTemplateId)}>
                                        <PiNotePencil className="btn-icon"></PiNotePencil>Edit
                                    </Button> : null}
                                {this.props.campaignType === "My Templates" ?
                                    <Button
                                        variant="secondary"
                                        className="mr-2"
                                        onClick={(e) =>
                                            this.deleteCampaignTemplate(this.props.campaignTemplateId)
                                        }
                                    ><PiTrash className="btn-icon"></PiTrash>Delete</Button> : null}
                                <Button
                                    variant="secondary"
                                    className="mr-2"
                                    onClick={(e) =>
                                        this.copyCampaignTemplate(this.props.campaignTemplateId)
                                    }
                                >
                                    <PiCopy className="btn-icon"></PiCopy>Clone</Button>
                                {this.props.campaignType === "My Templates" && <>

                                    {isDraftTemplate ? (
                                        <OverlayTrigger placement="top" overlay={testDraftTemplateTooltip}>
                                            <span className="d-inline-block">
                                                <Button
                                                    variant="secondary"
                                                    className="mr-2"
                                                    disabled
                                                    style={{ pointerEvents: 'none' }}
                                                >
                                                    <PiTelegramLogo className="btn-icon"></PiTelegramLogo>Test Template
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                    ) : (
                                        <Button variant="secondary" className="mr-2" onClick={e => this.setState({ showTestModal: true })}><PiTelegramLogo className="btn-icon"></PiTelegramLogo>Test Template</Button>
                                    )}
                                    {isDraftTemplate ?
                                        <OverlayTrigger placement="top" overlay={draftTemplateTooltip}>
                                            <span className="d-inline-block">
                                                <Button
                                                    variant="primary"
                                                    disabled
                                                    style={{ pointerEvents: 'none' }}
                                                >
                                                    <AddSharpIcon className="btn-icon"></AddSharpIcon>
                                                    Create Campaign
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                        :
                                        <Button variant="primary" onClick={this.launchCampaignTemplate}> <AddSharpIcon className="btn-icon"></AddSharpIcon>Create Campaign</Button>
                                    }
                                </>}
                                {isSystemTemplate && <>
                                    <Button variant="secondary" className="mr-2" onClick={() => this.handleSystemClone("test")}>
                                        <PiTelegramLogo className="btn-icon"></PiTelegramLogo>Test Template
                                    </Button>
                                    <Button variant="primary" onClick={() => this.handleSystemClone("create")}>
                                        <AddSharpIcon className="btn-icon"></AddSharpIcon>Create Campaign
                                    </Button>
                                </>}
                                <p className="badgeYn tdBadge">{this.props.campaignType === "My Templates"? "Custom Templates": this.props.campaignType}</p>
                            </div>: null
                        }
                        <div className='templateDetailsWrapper'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <div className='templateList'>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className='keyHeading'>Template Name:</td>
                                                    {/* {(this.state.attackType === "WhatsApp" || this.state.attackType === "Telegram") ? <td className='keyHeading'>Message Name:</td> : ""} */}
                                                    <td className='valueHeading'>{this.state.campaignName}</td>
                                                </tr>

                                                <tr>
                                                    <td className='keyHeading'>Template Category: </td>
                                                    <td className='valueHeading'><span className="p-badge">{this.state.category}</span></td>
                                                </tr>
                                            </tbody>
                                        </Table>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className='templateList'>
                                        <Table>
                                            <tbody>
                                                {/* Type of Simulation is a campaign-level setting now; not shown on templates. */}
                                                <tr>
                                                    <td className='keyHeading'>Attack Vector : </td>
                                                    <td className='valueHeading'>{this.state.attackType}</td>
                                                </tr>
                                                <tr>
                                                    <td className='keyHeading'>Language:</td>
                                                    <td className='valueHeading'>{this.state.language}</td>
                                                </tr>
                                                {/* Credential Harvesting is a campaign-level setting now; not shown on templates. */}
                                            </tbody>
                                        </Table>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {(!(this.state.attackType === 'Vishing' && this.state.targetInteractionType === "outbound") && this.state.attackType !== 'Training + Quiz' && this.state.simulationType !== "	Simulation Attack") ?
                            <div className='tabTamplate' id="tab-wrapper">
                                <Tabs activeKey={this.state.tab} onSelect={(tab) => this.setState({ tab: tab })}>
                                    <Tab eventKey="simulation" title="simulation">
                                        <div className="row">
                                            <div className="col-md-4">
                                                {(this.state.attackType === "Phishing" || this.state.attackType === "Ransomware" || this.state.attackType === "Attachment" || this.state.attackType === "QRcode" || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "inbound") || isAiWhatsapp) ?
                                                    <div className='contHeading'>
                                                        <h6>Email Template </h6>
                                                    </div> : (
                                                        isNormalWhatsapp || this.state.attackType === "Telegram" ?
                                                            <div className='contHeading'>
                                                                <h6>Message Template </h6>
                                                            </div> : "Template"
                                                    )
                                                }

                                                <div className="img-hover-wrap templateView" onClick={e => {
                                                    this.state.templateImg ?
                                                        this.setState({
                                                            showThumbnail: true,
                                                            currentSrc: this.state.templateImg,
                                                            previewType: 'template'
                                                        }) :
                                                        toast.info('Email Template Image Not Available')
                                                }}>
                                                    <div className='cardImg'>
                                                        <img src={!this.state.templateImg ? imageDefault : this.state.templateImg} className="img-fluid" alt=""></img>
                                                        <div className='hover-btn'>
                                                            <PiArrowsOutThin className="btn-icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.attackType !== "Vishing" &&
                                                <>
                                                    {(this.state.landing_url || this.state.capture_credentials || this.state.capture_passwords) && !isAiWhatsapp ?
                                                        <div className={`col-md-4${dimCredentialHarvestingSections ? ' preview-section-disabled' : ''}`}>
                                                            <div className='contHeading'>
                                                                <h6>Landing Page </h6>
                                                            </div>
                                                            <div className="img-hover-wrap templateView" onClick={e => {
                                                                if (dimCredentialHarvestingSections) return;
                                                                this.state.pageImg ?
                                                                    this.setState({
                                                                        showThumbnail: true,
                                                                        currentSrc: this.state.pageImg,
                                                                        previewType: 'page'
                                                                    }) :
                                                                    toast.info('Landing Page Image Not Available')
                                                            }}>
                                                                <div className='cardImg'>
                                                                    <img src={!this.state.pageImg ? imageDefault : this.state.pageImg} className="img-fluid" alt=""></img>
                                                                    <div className='hover-btn'>
                                                                        <PiArrowsOutThin className="btn-icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : null
                                                    }
                                                    {this.state.attackType !== "Ransomware" && !isAiWhatsapp && (
                                                        <div className="col-md-4">
                                                            <div className='contHeading'>
                                                                <h6>Awareness Page </h6>
                                                            </div>
                                                            <div className="img-hover-wrap templateView" onClick={e => {
                                                                this.state.awarenessPath ?
                                                                    this.setState({
                                                                        showThumbnail: true,
                                                                        currentSrc: this.state.awarenessPath,
                                                                        previewType: 'awareness'
                                                                    }) :
                                                                    toast.info('Awareness Page Image Not Available');
                                                            }}>
                                                                <div className='cardImg'>
                                                                    <img src={!this.state.awarenessPath ? imageDefault : this.state.awarenessPath} className="img-fluid" alt=""></img>
                                                                    <div className='hover-btn'>
                                                                        <PiArrowsOutThin className="btn-icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            }
                                        </div>
                                        <div className='url-wrapper'>
                                            <div className="row">
                                                {this.state.attackType === "Phishing" || this.state.attackType === "Ransomware" || this.state.attackType === "Attachment" || this.state.attackType === "QRcode" || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "inbound") || isAiWhatsapp ?
                                                    <div className='col-md-4'>
                                                        <div className='contHeading'>
                                                            <h6>Subject </h6>
                                                            <p>{!this.state.subject ? "No Subject Found" : this.state.subject}</p>
                                                        </div>

                                                        <div className='contHeading'>
                                                            <h6>Attacker Profile </h6>
                                                            <p> {!this.state.from_address ? "No Attacker Profile Found" : this.state.from_address}</p>
                                                        </div>
                                                    </div> : <div className='col-md-4'></div>
                                                }
                                                {this.state.attackType !== "Vishing" &&
                                                    <>
                                                        {(this.state.landing_url || this.state.capture_credentials || this.state.capture_passwords) && !isAiWhatsapp ?
                                                            <div className={`col-md-4${dimCredentialHarvestingSections ? ' preview-section-disabled' : ''}`}>
                                                                <div className='contHeading'>
                                                                    <h6>Landing Url </h6>
                                                                    <p>{!this.state.landing_url ? "No URL Found" : this.state.landing_url}</p>
                                                                </div>
                                                                {
                                                                    this.state.attackType !== "Ransomware" && (

                                                                        <Table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className='keyHeading'>Capture Credential </td>
                                                                                    <td className='valueHeading'> {this.state.capture_credentials ? <p className="badgeYn yes-badges">Yes</p> : <p className="badgeYn no-badges">No</p>}</td>
                                                                                </tr>

                                                                                <tr>
                                                                                    <td className='keyHeading'>Capture Password </td>
                                                                                    <td className='valueHeading'>{this.state.capture_passwords ? <p className="badgeYn yes-badges">Yes</p> : <p className="badgeYn no-badges">No</p>}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>

                                                                    )
                                                                }

                                                            </div> : null
                                                        }
                                                        {this.props.campaignType === "My Templates" &&
                                                            this.state.attackType !== "Ransomware" &&
                                                            this.state.attackType !== "Vishing" &&
                                                            !isAiWhatsapp && (
                                                                <div className='col-md-4'>
                                                                    <div className='contHeading'>
                                                                        <h6>Awareness Url </h6>
                                                                        <p>{!this.state.awarenessUrl ? "No URL Found" : this.state.awarenessUrl}</p>
                                                                    </div>

                                                                </div>
                                                            )}
                                                    </>
                                                }
                                            </div>

                                        </div>

                                    </Tab>
                                    {this.state.simulationType === "Simulation Attack + Training" &&
                                        <Tab eventKey="training" title="training">

                                            <div className='contHeading'>
                                                <h6>Training </h6>
                                            </div>
                                            <div className="tableContainerWrapInner">
                                                <Table className="training-table" borderless>
                                                    <thead>
                                                        <tr>
                                                            <th>Course</th>
                                                            <th>Date</th>
                                                            <th>LECTURES</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.lmsCourses.length ? this.state.lmsCourses.map((course, index) => {
                                                            return <tr key={index} className="setcheckBox">
                                                                <td className="onlyForPinter">
                                                                    <div className="flexTableData">
                                                                        <div className="companyLogoIcon">
                                                                            <Image src={this.state.imageURL + course.logo} alt="no image" className="training-img"></Image>
                                                                        </div>
                                                                        <div>
                                                                            <h6>{course.name}</h6>
                                                                            <p>{course.courseType}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td><p>{getDate(course.createdAt)}</p></td>
                                                                <td>{course.totalLecture}</td>
                                                                <td> <p className={`badges ${this.state.classCSS[this.getNewCourseStatus(course.status, course.id)]}`}> {this.getNewCourseStatus(course.status, course.id)}</p></td>
                                                                {/* <td>{course.Language.name}</td> */}
                                                                <td><VisibilitySharpIcon className="btn-icon training-preview-icon" onClick={e => this.handleLMS(course.id)} ></VisibilitySharpIcon></td>
                                                            </tr>
                                                        }) : <p style={{ margin: 0, padding: "10px", fontSize: "12px" }}>No Data Found</p>}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Tab>
                                    }
                                </Tabs>
                            </div> : null
                        }
                        <PreviewThumbnail
                            src={this.state.currentSrc}
                            attackType={this.state.attackType}
                            previewType={this.state.previewType}
                            showModal={this.state.showThumbnail}
                            showHandle={e => this.setState({ showThumbnail: false })}
                            targetInteractionType={this.state.targetInteractionType}
                        ></PreviewThumbnail>
                        <TestEmails
                            attackType={this.state.attackType}
                            targetInteractionType={this.state.targetInteractionType}
                            emails={this.state.emails}
                            firstname={this.state.firstname}
                            lastname={this.state.lastname}
                            nextPath={path => this.props.nextPath(path)}
                            testCampaign={this.testCampaign}
                            showModal={this.state.showTestModal}
                            showHandle={e => this.setState({ showTestModal: false })}
                        ></TestEmails>

                        <LaunchNewModal
                            showModal={this.state.showLaunchNewModal}
                            showHandle={() => this.setState({ showLaunchNewModal: false })}
                            nextPath={this.props.nextPath}
                            campaignTemplateId={effectiveTemplateId}
                            attackType={this.state.attackType}
                            simulationType={this.state.simulationType}
                            credentialHarvesting={this.state.credential_harvesting}
                            categoryId={this.state.categoryId}
                            prefilledFromTemplate={!!(
                                this.state.attackType &&
                                this.state.simulationType &&
                                effectiveTemplateId
                            )}
                            targetInteractionType={this.state.targetInteractionType}
                            isAIbased={this.state.isAIbased}
                        />

                        {this.state['loading'] ? <Loader /> : null}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
